<template>
<div>
    <Breadcrumbs main="Procuremnet" submain="View" title="Purchase Requisition" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12">
                <px-card>
                    <div slot="with-padding">
                        <div class="form theme-form">
                            <div style="display: flex; justify-content: flex-end;" v-if="requisition.status === 'approved'">
                                <router-link :to="{ path: '/procurement/rfp/create', query: { pr: this.$route.params.id } }">
                                    <b-button variant="primary" class="mb-4">Create RFP</b-button>
                                </router-link>
                            </div>
                            <div class="row">
                                <div class="col-sm-4">
                                    <div style="display: flex; flex-direction: column; gap: 8px; align-items: start;">
                                        <label class="pr-4">Status</label> 
                                        <span v-if="requisition.status === 'draft'">
                                            <b-badge variant="info" style="font-size: 14px; margin-bottom: 12px;" class="text-uppercase">{{ requisition.status }}</b-badge>
                                        </span>
                                        <span v-if="requisition.status === 'submitted'">
                                            <b-badge variant="primary" style="font-size: 14px; margin-bottom: 12px;" class="text-uppercase">{{ requisition.status }}</b-badge>
                                        </span>
                                        <span v-if="requisition.status === 'approved'">
                                            <b-badge variant="success" style="font-size: 14px; margin-bottom: 12px;" class="text-uppercase">{{ requisition.status }}</b-badge>
                                        </span>
                                        <span v-if="requisition.status === 'rfp_raised'">
                                            <b-badge variant="primary" style="font-size: 14px; margin-bottom: 12px;" class="text-uppercase">RFP Raised</b-badge>
                                        </span>
                                        <span v-if="requisition.status === 'rejected'">
                                            <b-badge variant="danger" style="font-size: 14px; margin-bottom: 12px;" class="text-uppercase">{{ requisition.status }}</b-badge>
                                        </span>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label>Approved By</label>
                                        <input class="form-control" type="text" placeholder="Enter approved by" v-model="requisition.approved_by_name" style="height: 44px;" disabled>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label>Approval Date</label>
                                        <input class="form-control" type="text" placeholder="Enter approval date" v-model="requisition.approved_at" style="height: 44px;" disabled>
                                    </div>
                                </div>
                            </div>

                            <div class="row" v-if="requisition.rejection_reason">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label>Rejection Reason</label>
                                        <textarea class="form-control" placeholder="Enter rejection reason" v-model="requisition.rejection_reason" rows="2" disabled></textarea>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>PR Number</label>
                                        <input class="form-control" type="text" placeholder="Enter purchase requisition number" v-model="requisition.pr_number" style="height: 44px;" disabled>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Requested By</label>
                                        <input class="form-control" type="text" placeholder="Enter requested by" v-model="requisition.requested_by_name" style="height: 44px;" disabled>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Title</label>
                                        <input class="form-control" type="text" placeholder="Enter requisition title" v-model="requisition.title" style="height: 44px;" disabled>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Department</label>
                                        <input class="form-control" type="text" placeholder="Enter requisition department" v-model="requisition.department_name" style="height: 44px;" disabled>
                                    </div>
                                </div>
                            </div>
                
                            <div class="row">
                                <div class="col">
                                    <div class="form-group">
                                        <label>Items</label>
                                        <ItemTable
                                            v-if="requisition.items && requisition.items.length"
                                            :tableData="requisition.items"
                                            style="margin-bottom: 10px;"
                                            @itemsUpdated="updateItems"
                                            :showActions="false"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-4"></div>
                                <div class="col-sm-8">
                                    <div class="form-group" style="display: flex; gap: 25px; align-items: center;">
                                        <label style="margin-top: 8px; font-weight: 500; width: 120px;">Grand Total</label>
                                        <input class="form-control" type="number" placeholder="Enter grand total" v-model="total" disabled style="height: 44px;" />
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col">
                                    <div class="form-group">
                                        <label>Purpose</label>
                                        <textarea class="form-control" id="exampleFormControlTextarea4" placeholder="Enter note..." rows="2" v-model="requisition.purpose" disabled></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </px-card>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import {
    computed
} from "vue";
import ItemTable from "./edit-item-table.vue";
import moment from "moment";

export default {
    components: {
        ItemTable,
    },

    data() {
        return {
            requisition: {
                pr_number: '',
                title: '',
                department_name: null,
                items: [],
                purpose: null,
                requested_by_name: null,
                status: null,
                rejection_reason: null,
                approved_by_name: null,
                approved_at: null
            },
            total: computed(() => {
                let total = 0;
                if (this.requisition.items.length >= 1) {
                    this.requisition.items.map((item) => {
                        total = total + item.estimated_total;
                    });
                }
                return total;
            })
        }
    },

    computed: {
        ...mapState({
            detail: state => state.purchaseRequisition.requisition_detail
        })
    },

    mounted() {
        this.$store.dispatch("purchaseRequisition/fetchPurchaseRequisitionDetail", this.$route.params.id);
    },

    watch: {
        detail(oldValue, newValue) {
            this.requisition.pr_number = this.detail.pr_number
            this.requisition.title = this.detail.title
            this.requisition.department_name = this.detail.department_name
            this.requisition.items = this.detail.items
            this.requisition.purpose = this.detail.purpose
            this.requisition.requested_by_name = this.detail.requested_by_name
            this.requisition.status = this.detail.status
            this.requisition.rejection_reason = this.detail.rejection_reason
            this.requisition.approved_by_name = this.detail.approved_by_name
            this.requisition.approved_at = this.detail.approved_at ? moment(this.detail.approved_at).format('YYYY-MM-DD') : null
        }
    },

    methods: {
        updateItems(data) {
            if (data) {
                this.requisition.items = data;
            }
        }
    }
};
</script>
